import React from 'react';

let ClassSelect = ({currentFilters, setFilters}) => {


  let handleChange = (e) => {
    let newFilters = {...currentFilters};
    newFilters["class"] = e.target.value;
    setFilters(newFilters);
  }

  return (
    <div className="class-select">
      <label htmlFor="class">Class:</label>
      <select id="class" defaultValue={currentFilters["class"]} onChange={handleChange}>
        <optgroup label="Core Classes">
          <option value="sor">Sorcerer</option>
          <option value="wiz">Wizard</option>
          <option value="cleric">Cleric</option>
          <option value="druid">Druid</option>
          <option value="ranger">Ranger</option>
          <option value="bard">Bard</option>
          <option value="paladin">Paladin</option>
        </optgroup>
        <optgroup label="Base Classes">
          <option value="alchemist">Alchemist</option>
          <option value="summoner">Summoner</option>
          <option value="summoner_unchained">Unchained Summoner</option>
          <option value="witch">Witch</option>
          <option value="inquisitor">Inquisitor</option>
          <option value="oracle">Oracle</option>
          <option value="magus">Magus</option>
        </optgroup>
        <optgroup label="Alternate Classes">
        <option value="antipaladin">Anti-Paladin</option>
        </optgroup>
        <optgroup label="Hybrid Classes">
          <option value="bloodrager">Blood Rager</option>
          <option value="shaman">Shaman</option>
          <option value="skald">Skald</option>
          <option value="investigator">Investigator</option>
          <option value="hunter">Hunter</option>
        </optgroup>
        <optgroup label="Occult Classes">
          <option value="psychic">Psychic</option>
          <option value="medium">Medium</option>
          <option value="mesmerist">Mesmerist</option>
          <option value="occultist">Occultist</option>
          <option value="spiritualist">Spiritualist</option>
        </optgroup>
        <optgroup label="NPC Classes">
        <option value="adept">Adept</option>
        </optgroup>
      </select>
      </div>
  )
};
export default ClassSelect;